import useLang from 'hooks/useLang';
import usePortalModal from 'hooks/usePortalModal';
import { functionUtils } from 'utils';
import Popup from './popup';

const WelcomeModal = ({ isShow, title, content, action, actionClose }) => {
  const { t } = useLang();
  const { closePortalModalName } = usePortalModal();

  const handleOnClick = () => {
    if (functionUtils.isFunction(action)) {
      action();
    }
    closePortalModalName();
  };

  const handleOnClose = () => {
    if (functionUtils.isFunction(actionClose)) {
      actionClose();
    }
    closePortalModalName();
  };

  return (
    <Popup
      isOpen={isShow}
      text={title || ''}
      content={content || ''}
      alignContent="center"
      buttonLabel1={t('button_back')}
      onClick={handleOnClick}
      onClose={handleOnClose}
      isClickBackdropToClose={true}
    />
  );
};

export default WelcomeModal;
